import { noAuthRequest } from 'api/helpers';
import { GET_ISSUE_DETAILS, RESET_ISSUE_DETAILS } from '../actionTypes';
import URL from 'api/endpoints';

// get issue details for specific issue
export const getIssueDetails = (params = '') => {
  return function (dispatch) {
    noAuthRequest.get(
      URL.issueDetails + params,
      (res) => {
        console.log('get issue details response', res);
        dispatch({
          type: GET_ISSUE_DETAILS,
          payload: { data: res },
        });
      },
      (err) => {
        console.log('get issue details error', err);
      }
    );
  };
};

// Resets state data for issue details
export const resetIssueDetails = () => {
  return function (dispatch) {
    dispatch({
      type: RESET_ISSUE_DETAILS,
    });
  };
};
